import { useMemo } from 'react';
import { orderList } from '../../../utils';

const Filters = (vm) => {
  const filteredInteractions = useMemo(() => {
    const q = vm.query.trim().toLowerCase();
    let sortedInteractions = vm.interactions;

    if (q) {
      sortedInteractions = vm.interactions.filter((i) => {
        const nombre = `${i.Name ?? ''}`.toLowerCase();
        return nombre.includes(q);
      });
    }

    return orderList(sortedInteractions, vm.sortConfig);
  }, [vm.interactions, vm.query, vm.sortConfig]);

  const displayedInteractions = useMemo(() => {
    if (vm.mode !== 'resume') return filteredInteractions;
    return filteredInteractions.slice(0, vm.amount);
  }, [filteredInteractions, vm.mode, vm.amount]);

  const handleSort = async (column) => {
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    vm.setSortConfig((prevConfig) => {
      const sameColumn = prevConfig.column === column;
      return {
        column,
        direction: sameColumn
          ? (prevConfig.direction === 'asc' ? 'desc' : 'asc')
          : 'asc',
      };
    });
  };

  const setSortColumn = async (column) => {
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    vm.setSortConfig((prev) => ({ ...prev, column }));
  };

  const toggleSortDirection = async () => {
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    vm.setSortConfig((prev) => ({
      ...prev,
      direction: prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  return {
    filteredInteractions,
    displayedInteractions,
    handleSort,
    setSortColumn,
    toggleSortDirection,
  };
};

export default Filters;
